// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { useRequest } from "redux-query-react";
import { createSelector } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import { isEqual } from "lodash";
import * as runtime from '../runtime';
import { DatapointMetadataFromJSON, } from '../models';
/**
 * Get all datapoints with metadata
 * Get Datapoints Metadata
 */
export function getDatapointsMetadataRaw(requestConfig = {}) {
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    const { meta = {} } = requestConfig;
    const config = {
        url: runtime.BASE_PATH + `/datapointsmetadata` + queryString,
        meta,
        update: requestConfig.update || {
            DatapointsMetadata: (prevValue, transformedValue) => {
                return { ...prevValue, ...transformedValue };
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'GET',
            headers: headerParameters,
        },
        body: queryParameters,
        transform: requestConfig.transform ? requestConfig.transform : (body, text) => {
            const objResponse = body.map(DatapointMetadataFromJSON);
            return {
                DatapointsMetadata: objResponse.reduce((map, obj) => {
                    map[obj.id] = obj;
                    return map;
                }, {})
            };
        }
    };
    config.queryKey = requestConfig.queryKey || `GetDatapointsMetadata`;
    return config;
}
/**
* Get all datapoints with metadata
* Get Datapoints Metadata
*/
/**
 * Use this selectors to get a record of all Array<DatapointMetadata>, with their ids as keys
 * @returns A record of Array<DatapointMetadata> object, with their ids as keys
 */
export const useDatapointsMetadataRecordSelector = () => useSelector((state) => state.entities.DatapointsMetadata, isEqual);
const DatapointsMetadataArraySelector = createSelector((state) => state.entities.DatapointsMetadata, (selectedSubState) => Object.keys(selectedSubState).map((id) => selectedSubState[id]));
/**
 * Use this selector to get a reference to a flat Array<DatapointMetadata>.
 * If you are doing transformation on this object, consider using useDatapointsMetadataRecordSelector instead for performances
 * @returns An array containing all loaded DatapointsMetadata
 */
export const useDatapointsMetadataArraySelector = () => useSelector(DatapointsMetadataArraySelector, isEqual);
/**
 * Request hook for Array<DatapointMetadata>
 * @param customQueryConfig TypedQueryConfig options set here will override default options.
 * @returns an array containg the data, query status, and a call for refresh
 * (note : refresh shouldn't be necessary, update to the state should be handle by mutators)
 */
export const useGetDatapointsMetadata = (customQueryConfig) => {
    const [querystate, forceRefresh] = useRequest(getDatapointsMetadataRaw(customQueryConfig));
    return [
        useDatapointsMetadataArraySelector(),
        querystate,
        forceRefresh
    ];
};
export function getDatapointsMetadata(requestConfig) {
    return getDatapointsMetadataRaw(requestConfig);
}
